module.exports = __webpack_public_path__ + "static/media/young4_s.fa7077bf.jpg";